




























































































































































































































import {
  Prop,
  Emit,
} from 'vue-property-decorator';
import { Mixins, Component } from 'vue-mixin-decorator';
import AuthConnector from '@/connector/Auth.vue';
import DialogConnector from '@/connector/Dialog.vue';
import ProfileConnector from '@/connector/Profile.vue';
import BankMixin from '@/mixins/bankMixin';
import CreditTurnMixin from '@/mixins/CreditTurnMixin';
import BankLogo from '@/components/BankLogo.vue';

@Component({
  components: {
    AuthConnector,
    DialogConnector,
    ProfileConnector,
    BankLogo,
  },
})
// eslint-disable-next-line max-len
export default class DepositDialog extends Mixins<BankMixin & CreditTurnMixin>(BankMixin, CreditTurnMixin) {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public banks: Array<any> = [];

  public showlinkLine: boolean = false;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  getAvailableBank(clientBank: string) {
    if (clientBank === 'truemoney') {
      return this.banks.filter((data) => data.bank === 'truemoney');
    }
    return this.banks.filter((data) => data.bank !== 'truemoney');
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  public async copyAccountNumber(id: string) {
    const copyText = document.getElementById(id);
    if (copyText) {
      const value = copyText?.innerText;
      navigator.clipboard.writeText(value);
      this.$store.commit('Snackbar/showNotification', { message: `คัดลอกเลขบัญชี ${value} แล้ว`, error: false });
    }
  }
}
